import { apiSlice } from './apiSlice';
import { RENTS_URL } from '../constants';

export const rentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new rent record
    createRent: builder.mutation({
      query: (data) => ({
        url: RENTS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Rents'],
    }),

    // Get all rents (Admin)
    getRents: builder.query({
      query: () => ({
        url: RENTS_URL,
      }),
      providesTags: ['Rents'],
      keepUnusedDataFor: 5,
    }),

    // Get rents for a specific tenant
    getRentsByTenant: builder.query({
      query: (tenantId) => ({
        url: `${RENTS_URL}/tenant/${tenantId}`,
      }),
      providesTags: ['Rents'],
      keepUnusedDataFor: 5,
    }),

    // Get latest rent end date for a tenant
    getLatestEndDateByTenant: builder.query({
      query: (tenantId) => ({
        url: `${RENTS_URL}/tenant/${tenantId}/latest`,
      }),
      providesTags: ['Rents'],
      keepUnusedDataFor: 5,
    }),

    // Get details of a single rent record
    getRentDetails: builder.query({
      query: (rentId) => ({
        url: `${RENTS_URL}/${rentId}`,
      }),
      providesTags: ['Rents'],
      keepUnusedDataFor: 5,
    }),

    // Update a rent record
    updateRent: builder.mutation({
      query: ({ rentId, updatedData }) => ({
        url: `${RENTS_URL}/${rentId}`,
        method: 'PUT',
        body: updatedData,
      }),
      invalidatesTags: ['Rents'],
    }),

    // Delete a rent record
    deleteRent: builder.mutation({
      query: (rentId) => ({
        url: `${RENTS_URL}/${rentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Rents'],
    }),

    // Filter rents by year (prorated)
    getRentsByYear: builder.query({
      query: (year) => ({
        url: `${RENTS_URL}/filter`,
        params: { year },
      }),
      keepUnusedDataFor: 5,
    }),

    // Get total rent per landlord
    getTotalRentByLandlord: builder.query({
      query: () => ({
        url: `${RENTS_URL}/summary/landlord`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Filter rents by date range and group by house or landlord
    getRentsByDateRange: builder.query({
      query: ({ start, end, groupBy }) => ({
        url: `${RENTS_URL}/filter`,
        params: { start, end, groupBy },
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ NEW: Get daily rent totals (sum by recorded date)
    getDailyRentTotals: builder.query({
      query: ({ start, end }) => ({
        url: `${RENTS_URL}/daily`,
        params: { start, end },
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useCreateRentMutation,
  useGetRentsQuery,
  useGetRentsByTenantQuery,
  useGetLatestEndDateByTenantQuery,
  useGetRentDetailsQuery,
  useUpdateRentMutation,
  useDeleteRentMutation,
  useGetRentsByYearQuery,
  useGetRentsByDateRangeQuery,
  useGetTotalRentByLandlordQuery,
  useGetDailyRentTotalsQuery,   // ✅ new hook
} = rentsApiSlice;